import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Form, Input } from 'antd';
import { subscribe } from 'alfa';
import { withTranslation } from 'react-i18next';

import { Loading } from '../../../components/loading';
import BatchLoader from './batch-loader';
import ValidationSummary from './ValidationSummary';
import { lookupRepo } from '../../../repository/lookup';
import money from '../../../helpers/money';
import SignWindow from '../../../components/key/sign';

class CreationForm extends Component { // eslint-disable-line fp/no-class
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      rows: [],
      validated: [],
      canProcess: false,
      signVisible: false,
    };
  }

  destinationUrl = (value) => {
    const { account: { region_id: regionId } } = this.props;
    if (value.startsWith('http')) { return value; }
    return `${regionId.toLowerCase()}:${value}`;
  };


    validateRows = async (rows) => {
      const { validate, t } = this.props;
      this.setState({
        rows,
      });

      const urls = [];
      let validatedRows = rows.map((row) => {
        const validatedRow = validate(row, t);
        if (validatedRow.valid && validatedRow.lana_id) {
          urls.push(this.destinationUrl(validatedRow.lana_id));
        }
        return validatedRow;
      });

      if (urls.length) {
        let destinations;
        try {
          destinations = await lookupRepo.bulkUrlLookup(urls);
        } catch (error) {
          console.error('ERROR: CreationForm.validateRows(): error retrieving destination URIs', error); // eslint-disable-line no-console
          this.setState({ canProcess: false }, this.updateCanProcess);
          return;
        }

        validatedRows = validatedRows.map((row) => {
          const validatedRow = { ...row };
          if (!validatedRow.valid) { return validatedRow; }

          const destination = destinations[this.destinationUrl(validatedRow.lana_id)];
          if (!destination) {
            validatedRow.valid = false;
            validatedRow.validation = 'Unexpected error. Missing lookup data for this row.';
            return validatedRow;
          }

          if (destination.error) {
            validatedRow.valid = false;
            validatedRow.validation = destination.error;
            return validatedRow;
          }

          validatedRow.destination = destination;
          return validatedRow;
        });
      }

      this.setState({
        validated: validatedRows,
      }, this.updateCanProcess);
    };

    updateCanProcess = () => {
      const { validated } = this.state;
      const invalid = validated.filter(({ valid }) => !valid);
      if (invalid.length < 1) {
        this.setState({ canProcess: true });
      }
    };

    handleBatchDispath = () => {
      const { form } = this.props;
      form.validateFields((err, values) => {
        if (!err) {
          this.setState({
            description: values.description,
            signVisible: true,
          });
        }
      });
    };

    payload = () => {
      const { business, account } = this.props;
      const { validated } = this.state;
      return validated.map(({ id, now: vTS, amount, currency, destination }) => (
        {
          id,
          vTS,
          bID: business.id,
          a: money.toInt(amount, currency, false),
          c: currency,
          s: account.gateway_uri,
          d: (destination) ? destination.gateway_uri : null,
        }
      ));
    };

    submit = (sigs) => {
      const { validated } = this.state;
      const transactions = validated.map((row) => {
        const sig = sigs.find((s) => s.id === row.id).signature;
        return { ...row, signature: sig };
      });

      this.setState({
        signVisible: false,
      }, () => {
        const { description } = this.state;
        const { onSubmit } = this.props;
        if (onSubmit) { onSubmit(transactions, description); }
      });
    };

    render() {
      const { t, batchOptions, form: { getFieldDecorator }, account, summaryColumns } = this.props;
      const { loading, validated, canProcess, rows, signVisible } = this.state;

      const errors = validated.filter(({ valid }) => !valid);

      return (
        <Form>
          <Loading spinning={loading}>
            <Form.Item label={t('description')} className="mb0">
              {getFieldDecorator('description', {
                rules: [{
                  required: true,
                  message: t('batch.required.desc'),
                }],
              })(
                <Input name="description" />,
              )}
            </Form.Item>

            {
              ((!validated.length) || ((validated.length > 0) && (errors.length > 0)))
                && <BatchLoader onLoad={this.validateRows} csvOptions={batchOptions} />
            }

            <Form.Item className="mt5">
              <Button
                onClick={this.handleBatchDispath}
                disabled={!canProcess}
                type="primary"
                htmlType="submit"
                icon="upload"
              >
                {t('create')}
              </Button>
            </Form.Item>

            <ValidationSummary
              rows={rows}
              validated={validated}
              balance={money.toDisplay(account.balance.available, account.region_id)}
              summaryColumns={summaryColumns}
            />

            <SignWindow
              visible={signVisible}
              payload={this.payload()}
              onOk={this.submit}
              onCancel={() => this.setState({ signVisible: false })}
              multiple
            />
          </Loading>
        </Form>
      );
    }
}

CreationForm.propTypes = {
  account: PropTypes.shape({
    balance: PropTypes.shape({
      available: PropTypes.number,
    }),
    gateway_uri: PropTypes.string,
    region_id: PropTypes.string,
  }),
  batchOptions: PropTypes.object,
  business: PropTypes.shape({
    id: PropTypes.string,
  }),
  form: PropTypes.shape({
    validateFields: PropTypes.func,
    getFieldDecorator: PropTypes.func,
  }),
  onSubmit: PropTypes.func,
  summaryColumns: PropTypes.array,
  t: PropTypes.func,
  validate: PropTypes.func,
};

export { CreationForm };
export default subscribe(Form.create({ name: 'batch-new' })(withTranslation()(CreationForm)), ['business', 'account']);
